import { Injectable } from '@angular/core';
import { ServiceBase } from './service-base.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService extends ServiceBase {

  private seedFunctionBaseUrl = `${environment.seedFunctionApiUrl}`; // Durable Function base URL (e.g., Azure Function App URL)

  protected get organizationIntentBaseUrl(): string {
    return `${environment.sehApiUrl}OrganizationIntents`;
  }

  protected override get serviceDomain(): string {
    return 'organization';
  }

  private getUrl(functionName: string): string {
    return this.seedFunctionBaseUrl.replace('{0}', functionName);
  }

  startDataSeed(organizationId: string): Observable<any> {
    return this.httpClient.post(this.getUrl('StartProcess'), {}, { params: { organizationId } });
  }

  getOrchestrations(organizationId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(this.getUrl('GetOrchestrations'), { params: { organizationId, _t: Date.now().toString() } });
  }

  controlOrchestration(instanceId: string, action: string): Observable<any> {
    return this.httpClient.post(this.getUrl('ControlOrchestration'), { instanceId, action });
  }

  purgeOrchestration(instanceId: string, organizationId: string): Observable<any> {
    return this.httpClient.post(this.getUrl('PurgeOrchestration'), { instanceId, organizationId });
  }

  getOrganizationTypes(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/organizationTypes`);;
  }

  createOrganizationType(body: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/organizationTypes`, body);
  }

  getOrganizationIntents(selectedOrganizationId: any): Observable<any[]> {
    return this.httpClient.get<any[]>(this.organizationIntentBaseUrl, { params: { organizationId: selectedOrganizationId } });
  }

  toggleOrganizationIntent(selectedOrganizationId: any, intentId: any, isIncluded: boolean): Observable<any> {
    return this.httpClient.put<any[]>(this.organizationIntentBaseUrl, { organizationId: selectedOrganizationId, intentId: intentId, isIncluded: isIncluded });
  }

  bulkToggleOrganizationIntents(selectedOrganizationId: any, intentIds: any[], isIncluded: boolean): Observable<any> {
    return this.httpClient.post<any[]>(`${this.organizationIntentBaseUrl}/bulk-toggle`, { organizationId: selectedOrganizationId, intentIds: intentIds, isIncluded: isIncluded });
  }

 applyDataToEnvironment(organizationId: string, environmentId: string, datasetType: string, notes?: string) : Observable<void> {

  let numericDatasetType: DatasetType;
    switch (datasetType) {
      case 'Department':
        numericDatasetType = DatasetType.Department;
        break;
      case 'KbItem':
      case 'Knowledge Base':
        numericDatasetType = DatasetType.KbItem;
        break;
      default:
        throw new Error(`Invalid DatasetType: ${datasetType}`);
    }

     const body = { organizationId, environmentId, datasetType: numericDatasetType, notes };
    return this.httpClient.post<void>(`${this.baseUrl}/promote-data`, body);
  }

}

export enum DatasetType {
  Department = 0,
  KbItem = 1
}